module.exports = __webpack_public_path__ + "static/media/zaki-staff-web-hubton.118b3714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/zaki-staff-web-hubton.png
// module id = 177
// module chunks = 0